import type { FunctionComponent } from 'react';

export const SearchIcon: FunctionComponent = () => {
    return (
        <svg fill="none" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.25 12.25L10.2084 10.2083M11.6667 6.70833C11.6667 9.44675 9.44675 11.6667 6.70833 11.6667C3.96992 11.6667 1.75 9.44675 1.75 6.70833C1.75 3.96992 3.96992 1.75 6.70833 1.75C9.44675 1.75 11.6667 3.96992 11.6667 6.70833Z"
                stroke="#B2B2B0"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.2"
            />
        </svg>
    );
};
